/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = `<div class="swym-wishlist-grid" role="dialog" and aria-modal="true">
   {{#products}}
   <div aria-label="Product: {{dt}}"  role="group" class="swym-wishlist-item swym-is-anchor">

     <a href="{{du}}" class="swym-wishlist-image-wrapper">
       <img alt="{{ dt }}" class="swym-wishlist-image" src="{{iu}}">
     </a>
     <button class="swym-is-button">
       <div class="swym-title swym-title-1">
         {{dt}}
       </div>
     </button>
     <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
       {{variantinfo}}
     </div>
     <div class="swym-product-price swym-text swym-text-1">
       <div class="swym-product-final-price swym-value">
         {{cu}}{{pr}}
       </div>
     </div>
     <button id="swym-custom-add-toCartBtn" {{#isOutOfStock}} disabled {{/isOutOfStock}} {{#isInCart}} disabled {{/isInCart}}
     data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"
     class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button {{#isOutOfStock}} out-of-stock {{/isOutOfStock}}
     {{#isInCart}} swym-added{{/isInCart}}  {{^isInCart}}not-added{{/isInCart}} ">
     </button>
     <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">Remove</button>
   </div>
   {{/products}}
</div>`;

var noProductsMessageMarkup = `<div class="swym-empty-wishlist-container">
	<h3 class="swym-empty-wishlist-title swym-heading swym-heading-1">No Favorites saved yet.</h3>
	<p class="swym-empty-wishlist-text swym-text swym-text-1">Browse all products now.</p>

	<a class="swym-empty-wishlist-continue-btn" href="/collections/all">Shop All</a>
</div>`;


const wishlistContainerMain = document.querySelector('#modal-wishlist .swym-ui-component');
const wishlistCloseButtonMain = document.querySelector('#modal-wishlist .swym-ui-component button.modal-exit');

function getVariantInfo(variants) {
  try {
    let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function onAddToCartClick(e) {
  e.preventDefault();

  var productId = e.currentTarget.getAttribute("data-product-id");
  var variantId = e.currentTarget.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-product-url");
  e.target.classList.add('adding');
  e.target.classList.remove('not-added');
  window._swat.replayAddToCart({
    empi: productId,
    du: du
  }, variantId, function(c) {
    e.target.innerHTML = "";
    e.target.classList.add('swym-added');
    e.target.classList.remove('adding');
    e.target.setAttribute('disabled', true);
    e.target.setAttribute("data-state-cart", "swym-added");
    console.log("Successfully added product to cart.", c);
    /* update cart after adding a product to cart from wishlist */
    fetch("/cart.js").then(res => res.json()).then(updateCart => {
      if(updateCart.item_count == 1){
        jQuery('#cart-icon-bubble').append('<div class="cart-count-bubble"><span aria-hidden="true">'+(updateCart.item_count)+'</span></div>')
      } else{
        jQuery('.cart-count-bubble span').text(updateCart.item_count )
      }
    });
  }, function(e) {
    console.log(e);
  });
}

async function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function(products) {
    products.forEach(function(product) {
      if (epi && empi && product.epi == epi && product.empi == empi){
        window._swat.removeFromWishList(product, function() {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  })
}

async function fetchProductData(wishlist) {
  const productDataPromises = wishlist.map(async (listItem) => {
    const response = await fetch(`${listItem.du.split('?')[0]}.js`);
    listItem.productData = await response.json();
    return listItem;
  }); 
  return Promise.all(productDataPromises);
}

async function swymRenderWishlist(swat) {
  // Get wishlist items



  await swat.fetch(function(products) {
        (async () => {
    //console.log("sym products");
    //console.log(products);

    var wishlistContentsContainer = document.getElementById("wishlist-items-modal-container");

    const wishlistedProducts = await fetchProductData(products); 

    var formattedWishlistedProducts = wishlistedProducts.map(function(p) {
      p.pr = (p.productData.price / 100);
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
      p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
      p.isOutOfStock = p.stk == 0;
      p.iu = p.productData.featured_image;
      //console.log("next product p");
      //console.log(p);
      return p;
    });




    //console.log("sym formattedWishlistedProducts");
    //console.log(formattedWishlistedProducts);

    if (formattedWishlistedProducts.length > 0) {
      var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
        products: formattedWishlistedProducts
      });
      if (wishlistContentsContainer) {
        wishlistContentsContainer.innerHTML = productCardsMarkup;
        attachClickListeners();
      } else {
        console.log("Container not found, Wishlist Page element not found");
      }
      // Add Wishlist count to header title
      const wishlistCountElem = document.getElementById('wishlistCount')
      wishlistContainerMain.style.display = "block";
      wishlistCountElem.innerHTML = products.length;
    } else {
      wishlistContainerMain.style.display = "block";
      wishlistContentsContainer.innerHTML = noProductsMessageMarkup;
    }


    focusOnModalPopup();


    })();
  });
}

function focusOnModalPopup()
{
    var focusElementQuery = '#modal-wishlist .modal-close';
    if(document.querySelector(focusElementQuery) != null)
    {
      console.log("focusing on close for modal");
      var allInstances = document.querySelectorAll(focusElementQuery);
      console.log("count for instances to focus = " + allInstances.length);
      document.querySelector(focusElementQuery).focus();
    }
}

function focusOnHeaderWishIcon()
{
  var focusHeaderWishIcon = "a#header-wishlist";
  if(document.querySelector(focusHeaderWishIcon) != null)
  {
    console.log("focusing on header wish icon");
    var allInstances = document.querySelectorAll(focusHeaderWishIcon);
    console.log("count for instances to focus = " + allInstances.length);
    document.querySelector(focusHeaderWishIcon).focus();
  }
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  //   Add to cart Btns
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }
  //   Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
  }
  console.log("Events attached!");
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

const wishlistIcon = document.getElementById('header-wishlist');

wishlistIcon.addEventListener('click', function(){
  window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

  // const modalWishlist = document.getElementById('modal-wishlist');

  // Toggle the class that changes display property
  // modalWishlist.classList.toggle('wishlistToggle');

});


wishlistCloseButtonMain.addEventListener('click', function(){
  wishlistContainerMain.style.display = "none";
  focusOnHeaderWishIcon();
});